import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {translate} from "react-i18next";

import { loginButtonClick, requestPasswordClick, resetPhoneClick, confirmRegisterClick } from './actions';

@translate(['login'], {wait:true})
class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
    };
  }

  componentWillReceiveProps() {
    this.setState({isSubmitting: false});
  }

  render() {
    const {t} = this.props;
    return (
      <div className="container">
        <form className="popupForm popupPasswordForm" action="#">
          <div className="popup-car-wrap">
            <img width="91" height="86" src="images/img-popup-car.png" alt="" />
            <i></i>
          </div>
          <div className="stepTitle">
            <h2>{this.props.isConfirm ? t('login:confirmRegister') : t('login:enterPassword')}</h2>
            <p>
              {t('login:passwordSent')}
              {
                !this.props.isAfterConfirm ? <span>,<br /> {t('login:ifForgot')} —&nbsp;
                <a
                  onClick={e => {
                    e.preventDefault();
                    this.props.handleRequestPasswordClick(this.state.phone);
                  }}
                  href="">{t('login:getNew')}</a>
                </span> : null
              }
            </p>
          </div>
          <div className="popupForm__body">
            <div className="row error">
              <input className="inputText" type="password" placeholder={t('login:password')} onChange={e => {
                this.setState({
                  password: e.target.value,
                });
              }}/>
              { this.props.error.length > 0 ? <span className="error-message">{t('login:invalidPassword')}</span> : null }
            </div>
          </div>
          <div className="rowButton">
            {
              !this.props.isAfterConfirm ?
              <div>
                <a onClick={e => {
                  e.preventDefault();
                  this.props.back();
                }} className="more" href="">{t('login:changePhoneNumber')}</a>
              </div> : null
            }
            <br/>
            <button onClick={e => {
              e.preventDefault();
              this.setState({isSubmitting: true});
              this.props.isConfirm ? this.props.handleRegisterConfirmClick(this.state.password) : this.props.handleLoginClick(this.state.password);
            }} className="btn" href="">{ this.state.isSubmitting ? <span className="spinner"></span> : t('login:continue') }</button>
          </div>
        </form>
      </div>
    );
  }
}

Login.propTypes = {
  handleRequestPasswordClick: PropTypes.func,
  handleLoginClick: PropTypes.func,
  handleRegisterConfirmClick: PropTypes.func,
  back: PropTypes.func,
  error: PropTypes.string,
  isConfirm: PropTypes.bool,
  isAfterConfirm: PropTypes.bool,
};

export default connect(
  (state) => {
    return {
      error: state.auth.error,
    };
  },
  (dispatch) => {
    return {
      handleRequestPasswordClick() {
        return dispatch(requestPasswordClick());
      },
      handleLoginClick(password) {
        return dispatch(loginButtonClick({password}));
      },
      handleRegisterConfirmClick(password) {
        return dispatch(confirmRegisterClick({password}));
      },
      back() {
        return dispatch(resetPhoneClick());
      },
    };
  }
)(Login);



// WEBPACK FOOTER //
// ./src/components/Auth/Login.js